import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { messages } from 'i18n/localization';
import {
    Entity,
    File,
    ISubmodelElement,
    KeyTypes,
    MultiLanguageProperty,
    Property,
    SubmodelElementCollection,
} from 'api/v3/aas_core_meta/types';
import { GetKeyType } from 'util/KeyTypeUtil';
import { PropertyComponent } from '../../composits/aas-viewer/submodel-elements/PropertyComponent';
import { EntityComponent } from '../../composits/aas-viewer/submodel-elements/entity-component/EntityComponent';
import { MultiLanguagePropertyComponent } from '../../composits/aas-viewer/submodel-elements/MultiLanguagePropertyComponent';
import { FileComponent } from '../../composits/aas-viewer/submodel-elements/FileComponent';
import { SubmodelElementCollectionComponent } from '../../composits/aas-viewer/submodel-elements/SubmodelElementCollectionComponent';
import { DifferenceSymbol } from 'components/basics/DifferenceSymbol';

type CompareSubmodelElementProps = {
    readonly submodelElement?: ISubmodelElement;
    readonly isMarked?: boolean;
};

export function CompareSubmodelElement(props: CompareSubmodelElementProps) {
    const isMarked = props.isMarked;

    function getRenderElement() {
        if (!props.submodelElement) {
            return;
        }

        const submodelElementType = GetKeyType(props.submodelElement);

        switch (submodelElementType) {
            case KeyTypes.Property:
                return (
                    <>
                        <Box display="flex" alignItems="center">
                            {isMarked && <DifferenceSymbol />}
                            <Box display="inline-block">
                                <PropertyComponent property={props.submodelElement as Property} />
                            </Box>
                        </Box>
                    </>
                );
            case KeyTypes.SubmodelElementCollection:
                return (
                    <SubmodelElementCollectionComponent submodelElementCollection={props.submodelElement as SubmodelElementCollection} />
                );
            case KeyTypes.File:
                return <FileComponent file={props.submodelElement as File} />;
            case KeyTypes.MultiLanguageProperty:
                return (
                    <>
                        <Box display="flex" alignItems={'center'}>
                            {isMarked && <DifferenceSymbol />}
                            <Box display="inline-block">
                                <MultiLanguagePropertyComponent
                                    mLangProp={props.submodelElement as MultiLanguageProperty}
                                />
                            </Box>
                        </Box>
                    </>
                );
            case KeyTypes.Entity:
                return <EntityComponent entity={props.submodelElement as Entity} />;
            default:
                return (
                    <Typography color="error" variant="body2">
                        <FormattedMessage
                            {...messages.mnestix.unknownModelType}
                            values={{ type: `${submodelElementType}` }}
                        />
                    </Typography>
                );
        }
    }

    return <>{getRenderElement()}</>;
}
